import React from 'react';
import type { ChatInDocWorkspace } from '../../contexts/ChatInDocContext';

export interface AgentMentionAutocompleteProps {
  items: ChatInDocWorkspace[];
  highlightedIndex: number;
  onHighlightChange: (index: number) => void;
  onPick: (workspace: ChatInDocWorkspace) => void;
}

export const AgentMentionAutocomplete: React.FC<AgentMentionAutocompleteProps> = ({
  items,
  highlightedIndex,
  onHighlightChange,
  onPick,
}) => {
  if (items.length === 0) {
    return (
      <div
        className="absolute bottom-full left-0 right-0 mb-1 max-h-48 overflow-y-auto rounded-lg border border-gray-200 bg-white py-2 shadow-lg z-20"
        role="listbox"
      >
        <p className="px-3 py-2 text-sm text-gray-500">Nenhum agente corresponde ao filtro.</p>
      </div>
    );
  }

  return (
    <div
      className="absolute bottom-full left-0 right-0 mb-1 max-h-48 overflow-y-auto rounded-lg border border-gray-200 bg-white py-1 shadow-lg z-20"
      role="listbox"
      aria-label="Agentes de IA"
    >
      {items.map((w, i) => (
        <button
          key={w.id}
          type="button"
          role="option"
          aria-selected={i === highlightedIndex}
          className={`w-full text-left px-3 py-2 text-sm transition-colors ${
            i === highlightedIndex ? 'bg-blue-50 text-blue-900' : 'text-gray-800 hover:bg-gray-50'
          }`}
          onMouseEnter={() => onHighlightChange(i)}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onPick(w)}
        >
          <div className="font-medium">{w.assistantName || w.name}</div>
          {w.description ? (
            <div className="text-xs text-gray-500 line-clamp-2 mt-0.5">{w.description}</div>
          ) : null}
        </button>
      ))}
    </div>
  );
};
